import React from 'react';
import './collector-card-skeleton.css';

/** Aspect-stable placeholder for every collectible type and every card-sized loading surface. */
export default function CollectorCardSkeleton({
  kind,
  className = '',
}: {
  kind?: string;
  className?: string;
}) {
  return (
    <div className={`collector-card-skeleton ${className}`} data-kind={kind || 'unknown'} aria-hidden="true">
      <div className="collector-card-skeleton__top">
        <span className="collector-card-skeleton__brand" />
        <span className="collector-card-skeleton__edition" />
      </div>
      <div className="collector-card-skeleton__identity">
        <span />
        <span />
      </div>
      <div className="collector-card-skeleton__photo">
        <span className="collector-card-skeleton__photo-mark" />
      </div>
      <div className="collector-card-skeleton__facts">
        <span /><span /><span /><span />
      </div>
      <div className="collector-card-skeleton__footer">
        <span /><span />
      </div>
    </div>
  );
}
